module.exports = __webpack_public_path__ + "static/media/TwoGirls.fc00c6f1.png";